<template>
  <div class="contact" id="contact">
    <div class="border"></div>
    <div class="container">
      <h1>
        <font-awesome-icon icon="comments" />
        Kontakt
      </h1>
      <p class="text">Wir sind auch  <b>telefonisch</b>, <b>online</b>,
        per <b>Mail</b> oder direkt über das folgene <b>Formular</b> für Sie erreichbar.
      </p>
      <div class="flex-row">
        <div class="info">
          <h2>
            <font-awesome-icon icon="phone" class="phone-icon"/>
            Telefon <span class="alert">(Kein Notruf!)</span> 
          </h2>
          <p class="entry">
            <i>+ 49-7302-6288</i> <br>
          </p>
          <div class="space" />
          <h2>
            <font-awesome-icon icon="envelope" />
            E-Mail
          </h2>
          <p class="entry" title="(at) mit @ ersetzen">
            <i>briefkasten (at) ff-pfaffenhofen.de</i>
          </p>
          <div class="space" />
          <h2>
            <font-awesome-icon icon="globe" />
            Social Media
          </h2>
          <div class="social-media entry">
            <a href="https://www.facebook.com/Feuerwehr-Pfaffenhofen-an-der-Roth-109956954593455/">
              <i class="fab fa-facebook" />
            </a>
            <span class="seperator"> &bull; </span>
            <a href="https://www.instagram.com/ffpfaffenhofen/">
              <i class="fab fa-instagram" />
            </a>
          </div>
        </div>
        <div class="info">
          <h2>
            <font-awesome-icon icon="comment" />
            Direkt
          </h2>
          <div v-if="!formVisible">
          <p class="send-message" v-if="formSend">Nachricht erfolgreich abgeschickt.</p>
          <p class="description" v-else>
            Mit diesem Kontaktformular können Sie bequem mit uns in Verbindung treten.
            Schicken Sie uns Ihre Nachricht und wir melden uns so schnell wie möglich.
          </p>
          <button class="btn-primary" @click="showForm()">Formular Anzeigen</button>
          </div>
          <div class="form-container" v-if="formVisible">
            <span class="btn-close" @click="formVisible = false">
              <font-awesome-icon icon="times" />
            </span>
            <form class="contact-form" @submit.prevent="handleSubmit()">
              <label for="name">Ihr Name <span class="required">*</span></label>
              <input type="text" name="name" placeholder="Ihr Name" v-model="message.name">
              <p class="error-input" v-if="errorName">Feld muss ausgefüllt werden.</p>
              <label for="contact">Ihre E-Mail oder Telefonnummber 
                <span class="required">*</span>
              </label>
              <input type="text" name="name" placeholder="Ihre E-Mail oder Telefonnummer" v-model="message.contact">
              <p class="error-input" v-if="errorContact">Feld muss ausgefüllt werden.</p>
              <label for="msg">Ihre Nachricht <span class="required">*</span></label>
              <textarea name="msg" id="" rows="4" v-model="message.message"></textarea>
              <p class="error-input" v-if="errorMessage">Feld muss ausgefüllt werden.</p>
              <div class="btn-bar">
                <button class="btn-submit" type="submit">
                  <font-awesome-icon icon="comments" />
                  Absenden
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

    </div>
    <div class="border"></div>
  </div>
</template>

<script>

export default {
  name: 'HomeContact',
  data () {
    return {
      formVisible: false,
      errorName: false,
      errorContact: false,
      errorMessage: false,
      formSend: false,
      message: {
        name: "",
        contact: "",
        message: ""
      }
    }
  },
  methods: {
    showForm() {
      this.formVisible = true
      this.formSend = false
    },
    handleSubmit() {
      let error = false
      this.errorName = false
      this.errorContact = false
      this.errorMessage = false

      if(!this.message.name) {
        this.errorName = true
        error = true
      }

      if(!this.message.contact) {
        this.errorContact = true
        error = true
      }

      if(!this.message.message) {
        this.errorMessage = true
        error = true
      }

      if(error) return

      let data = {
        name: this.message.name,
        contact: this.message.contact,
        message: this.message.message
      }

      this.axios.post('https://ff-pfaffenhofen.de/api/v1/contact/create', 
        data , {withCredentials: true})
      .then(() => {
        this.formVisible = false
        this.message.name = ""
        this.message.contact = ""
        this.message.message = ""
        this.formSend = true
      })
    }
  },
  mounted () {
   
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/theme.scss";

.contact {
  background: $dark;
  padding: 6px 0px;
}

h1, p, a {
  text-align: center;
}

.container {
  padding: 50px 0 80px 0;
}

h1 {
  color: $light-0;
  font-size: 20px;
  text-align: center;

  svg {
    color: $primary-0;
    font-size: 38px;
    margin-right: 15px;
    transform: rotate(-15deg);
  }

  @include mini {
    font-size: 30px;
  }
}

.text {
  color: $light-0;
  opacity: 0.8;
  padding: 0px 10px;
}

.border {
  border-top: 2px solid $light-0;
}

.flex-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: center;
}

.info {
  width: 90%;

  @include tablet {
    width: 45%;
  }

  @include desktop {
    width: 42%;
  }

  h2 {
    text-align: center;
    color: $light-0;
    opacity: 0.8;
    font-size: 20px;
    font-weight: 200;

    svg {
      color: $primary-0;
      margin-right: 10px;
    }

    .alert {
      font-size: 16px;
      margin-left: 10px;
      opacity: 0.6;
    }
  }

  a {
    display: block;
    text-decoration: none;
  }
}

.entry {
  color: $light-0;
  font-weight: 400;
}

.description {
  color: $light-0;
  opacity: 0.6;
}

.form-container {
  padding: 10px 20px;
  background: $light-0;
  border: 1px solid lighten($gray-0, 15%);
  box-shadow: $shadow-medium;
  position: relative;
  border-radius: 4px;
}

label {
  display: block;
  color: lighten($dark, 20%);
  font-weight: 800;
  margin-top: 10px;

  .required {
    color: $primary-0;
  }
}

input, textarea {
  width: 100%;
  display: block;
  padding: 4px;
  font-size: 16px;
  border: 1px solid $gray;

}

.error-input {
  font-size: 14px;
  text-align: left;
  margin-top: 4px;
  color: $primary-0;
}

.send-message {
  color: $light-0;
  font-weight: bolder;
}

.btn-primary {
  padding: 6px 15px;
  margin: 0 auto;
  display: block;
  border: none;
  border-radius: 5px;
  color: $light-0;
  font-weight: 600;
  background: linear-gradient(lighten($primary-0, 15%), $primary-0);
  font-size: 14px;

  &:hover {
    background: linear-gradient(lighten($primary-0, 5%), darken($primary-0, 10%));
  }
}

.btn-close {
  position: absolute;
  right: 20px;
  top: 10px;
  opacity: 0.5;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
}

.btn-bar {
  margin-top: 20px;
  padding-bottom: 5px;
  display: flex;
  flex-direction: row-reverse;
}

.btn-submit {
  background: 0;
  border: 0;
  font-size: 16px;
  font-weight: 800;
  text-transform: uppercase;    
  cursor: pointer;
  color: lighten($dark, 20%);

  svg {
    color: $primary-0;
    margin-right: 5px;
    font-size: 20px;
  }
}

.social-media {

  display: flex;
  justify-content: center;
  place-items: center;
  gap: 4px;

  a {
    color: #eaeaea;
    font-size: 32px;
    margin: 0px 8px;

    &:hover {
      color: #fff;
    }
  }

  .seperator {
    color: #f2f2f2;
    font-size: 18px;
    opacity: 0.4;

    @include tablet {
      bottom: 2px;
    }
  }
}

.space {
  margin-bottom: 2rem;
}

</style>
